import React, {useEffect, useState} from 'react';
import axios from "axios";

const DeleteLearnerUtil = () => {
    const [phoneNumber, setPhoneNumber] = useState(undefined);
    const [email, setEmail] = useState(undefined);
    const [password, setPassword] = useState(undefined);
    const [isAuth, setIsAuth] = useState(false);
    useEffect(()=>{
        if(password==="adminRouteForDevs") setIsAuth(true);
    },[password])

    const handleSubmit = () => {
        const postData = {
            email:email,
            phoneNumber:phoneNumber,
            password:password
        }        
        axios
        .post(
        `${process.env.REACT_APP_BASE_URL}/api/learner/deleteLearner`,
        postData,
        )
        .then(function (response) {
            alert(JSON.stringify(response.data.message));
            setPhoneNumber(undefined);
            setEmail(undefined);
        })
        .catch(function (error) {
            console.log(error)
            alert("Internal Server Error")
        });
    }
    return (        
        <div className="container">
            Delete a learner (Only for developers)
            
                {isAuth?
                    <>  
                        <br/>
                        <span>
                            Enter Learner's Details
                        </span>
                        <form>
                            <input 
                                type="text" 
                                name="phoneNumber" 
                                placeholder={phoneNumber?phoneNumber:"Learner Phone Number"} 
                                onChange={(e)=>setPhoneNumber(e.target.value)}
                            />
                            <br/>
                            <input 
                                type="text" 
                                name="email" 
                                placeholder={email?email:"Learner Email"} 
                                onChange={(e)=>setEmail(e.target.value)}
                            />
                            <br/>
                            <input type="button" value="Submit" onClick={handleSubmit}/>
                        </form>
                    </>
                :
                    <>
                        <form>
                            <input 
                                type="password" 
                                name="password" 
                                placeholder={password?password:"Enter Password"}
                                onChange={(e)=>setPassword(e.target.value)}
                            />
                        </form>
                    </>
                }
        </div>
    );
};

export default DeleteLearnerUtil;